<template>
  <el-card shadow="never" class="l-main-card">
    <div class="l-table-toolbar">
      <l-auth-button type="primary" auth="msg_main_add_btn" @click="add_visible = true">添加</l-auth-button>
      <div class="l-simple-search-container">
        <el-input placeholder="请输入标题" v-model="search_data.keywords" class="input-with-select">
          <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
        </el-input>
      </div>
    </div>
    <l-table :data="data" v-loading="loading" row-key="id">
      <el-table-column fixed prop="index" label="序号" width="100"></el-table-column>
      <el-table-column prop="title" label="标题" min-width="200" show-overflow-tooltip></el-table-column>
      <el-table-column label="消息内容" min-width="300"  show-overflow-tooltip>
          <template slot-scope="scope" >
            <span v-html="scope.row.content"></span>
          </template>
      </el-table-column>
      <el-table-column label="发送对象" min-width="200">
        <template v-slot="{ row }">
          <el-tag size="mini" v-show="row.send_type == 1">系统消息（全部用户可见）</el-tag>
          <el-tag size="mini" v-show="row.send_type == 4">全部</el-tag>
          <el-tag size="mini" v-show="row.send_type == 2">内部员工</el-tag>
          <el-tag size="mini" v-show="row.send_type == 3">维修服务商</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="100">
        <template v-slot="{ row }">
          <l-auth-switch
            auth="msg_main_updState_btn"
            @change="() => updState(row)"
            v-model="row.state"
            :active-value="1"
            :inactive-value="0"
          />
        </template>
      </el-table-column>
      <el-table-column prop="create_time" label="创建时间" width="180"></el-table-column>
      <el-table-column prop="update_time" label="修改时间" width="180"></el-table-column>

      <el-table-column fixed="right" label="操作" width="180" align="center">
        <template slot-scope="{ row }">
          <l-auth-text-button type="primary" auth="msg_main_edit_btn" @click="showEdit(row.id)">
            <i class="el-icon-edit"></i>编辑
          </l-auth-text-button>
          <span class="l-action-separator">|</span>
          <l-auth-text-button type="danger" auth="msg_main_del_btn" @click="del(row.id)">
            <i class="el-icon-delete"></i>删除
          </l-auth-text-button>
        </template>
      </el-table-column>
    </l-table>

    <!--分页-->
    <l-page
      :total="count"
      @current-change="getList"
      @size-change="getList"
      :page-size.sync="page_size"
      :current-page.sync="page"
    ></l-page>

    <!--添加-->
    <l-dialog :visible.sync="add_visible" title="添加消息公告" width="700px">
      <l-msg-main-edit @on-success="onAddSucess" :visible.sync="add_visible" />
    </l-dialog>

    <!--编辑-->
    <l-dialog :visible.sync="edit_visible" title="编辑消息公告" width="700px">
      <l-msg-main-edit @on-success="onEditSuccess" :visible.sync="edit_visible" :id="edit_id" />
    </l-dialog>
  </el-card>
</template>

<script>
import Vue from "vue";
import Edit from "./Edit";
export default {
  components: {
    [Edit.name]: Edit
  },
  data() {
    return {
      data: [],
      count: 0,
      page: 1,
      page_size: Vue.$_config.page.page_size,
      loading: false,

      add_visible: false, //是否显示添加

      edit_visible: false, //是否显示编辑
      edit_id: 0,

      //搜索
      search_visible: false,
      search_data: {
        keywords: ""
      },
      rel_search_data: {},
      show_more_search: false
    };
  },

  mounted() {
    this.getList();
  },

  methods: {
    //获取数据
    getList() {
      this.loading = true;
      this.$_invoke("msgMain_getMyList", {
        page: this.page,
        page_size: this.page_size,
        ...this.rel_search_data
      })
        .then(ret => {
          this.data = ret.data;
          this.count = ret.count;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //点击搜索按钮
    onSearch() {
      this.page = 1;
      this.rel_search_data = this.search_data;
      this.getList();
    },

    //点击重置搜索框
    onReset() {
      this.$refs.search_form.resetFields();
      this.rel_search_data = {};
    },

    //添加成功回调
    onAddSucess() {
      this.add_visible = false;
      this.getList();
    },

    //显示修改界面
    showEdit(id) {
      this.edit_id = id;
      this.$nextTick(() => {
        this.edit_visible = true;
      });
    },

    //编辑成功回调
    onEditSuccess() {
      this.edit_visible = false;
      this.getList();
    },

    //修改状态
    updState(row) {
      this.$_invoke(`msgMain_updState`, {
        id: row.id,
        state: row.state
      })
        .then(() => {
          //row.state = ret.state;
          this.$_msg.success("修改状态成功");
        })
        .finally(() => {});
    },

    //删除
    del(id) {
      this.$confirm("确定删除该条记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$_invoke(`msgMain_delete`, { id }).then(() => {
            this.$_msg.success("删除成功");
            this.getList();
          });
        })
        .catch(() => {});
    }
  }
};
</script>
